// Pre-loaded games that can be launched via URL parameters

import sample from "../games/sample.json";
import cs51_part1 from "../games/cs51_part1.json";
import cs51_part2 from "../games/cs51_part2.json";
import gamy from "../games/gamy.json";

export const preloadedGames = {
    sample,
    cs51_part1,
    cs51_part2,
    gamy,
};
